import { wireAuthoring } from './authoring';

wireAuthoring();
